import React from 'react';

/**
 * Catches render-phase errors from the escape-hatch ECharts render and shows a fallback instead.
 * This is the frontend half of the escape-hatch defense (the backend sanitizer is the other) — a
 * malformed/incoherent option that slips through must degrade to the table, never break on stage.
 */
export class EscapeHatchBoundary extends React.Component<
  { fallback: React.ReactNode; children: React.ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {
    // Swallow — the fallback is shown. (No telemetry wired for the demo.)
  }

  render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}
